import isEmpty from 'lodash/fp/isEmpty'

export function isFeatureEnable(featureKey: string) {
  const featureFlag = process.env[`REACT_APP_FEATURE_${featureKey}`]
  return isEmpty(featureFlag) || featureFlag === 'true'
}
